import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import CommentIcon from 'material-ui-icons/Comment';
import Grid from 'material-ui/Grid';
import CardBox from 'components/CardBox';
import Avatar from 'material-ui/Avatar';
import Button from 'material-ui/Button';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import { filter } from 'lodash'

class MUISelector extends React.Component {
    state = {
        userList: []
    };

    handleToggle = (event, value) => {
        const { userList } = this.state;
        const newuserList = [...userList];
        if (filter(newuserList, ['id', value])[0].status)
            filter(newuserList, ['id', value])[0].status = false;
        else
            filter(newuserList, ['id', value])[0].status = true;
        this.setState({ userList: newuserList, });
    };

    handleToggleAll = (event, value) => {
        const { userList } = this.state;
        const newuserList = [...userList];
        _.forEach(newuserList, function (obj) {
            if (obj.status)
                _.set(obj, 'status', false);
            else
                _.set(obj, 'status', true);
        });
        this.setState({ userList: newuserList, });
    };

    render() {
        this.state.userList = this.props.userList

        console.log("User list ",this.state.userList)

        return (
            <div className="row mb-md-4 justify-content-md-center">
                <Card className="col-4 p-0 m-0">
                    <CardHeader className="pl-3 p-2 bg-primary text-center text-white">Available Team members</CardHeader>
                    <List style={{ maxHeight: 300, overflow: 'auto' }}>
                        {this.state.userList  ? this.state.userList.map(item =>
                            item.status ? null : <ListItem button key={item.id} onClick={event => this.handleToggle(event, item.id)}>
                                <ListItemText primary={item.userId} /> <i className="zmdi zmdi-arrow-right"></i>
                            </ListItem>,
                        ) : null}
                    </List>

                </Card>
                <div className="col-2 text-center align-self-center">
                    <CardBody>
                        <div className="row">

                            <div className="col-12">
                                <button type="button" className="btn btn-primary btn-lg" onClick={event => this.handleToggleAll(event)}>
                                    <i className="zmdi zmdi-swap"></i></button>


                            </div>



                        </div>
                    </CardBody>
                </div>
                <Card className="col-4 p-0 m-0">
                    <CardHeader className="pl-3 p-2 text-center bg-primary text-white">Selected Team members</CardHeader>


                    <List className="border-bottom-1" style={{ maxHeight: 300, overflow: 'auto' }}>
                        {this.state.userList ? this.state.userList.map(item =>
                            item.status ? <ListItem button key={item.id} onClick={event => this.handleToggle(event, item.id)}>
                                <i className="zmdi zmdi-arrow-left"></i> <ListItemText primary={item.userId} />
                            </ListItem> : null,
                        ) : null}
                    </List>

                </Card>
            </div>
        );
    }
}
export default MUISelector;


// WEBPACK FOOTER //
// ./app/muiselector.js